import { css, html } from "../helpers/webComponents";
import { MapService } from "../services/MapService";

const styles: string = css`
:host {
    position: absolute;
     top: 0;
      left: 0;
      display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        font-family: "Onesize";
         }

 rect {
    fill: #222; /* Donkere gebouwen */
    stroke: #666; /* Subtiele rand */
    stroke-width: 2px;
}

div {
    position: absolute;
    top: 25px;
    right: 10px;
}

     #close-button {
    background: red;
    color: white;
    border: none;
    padding: 8px 12px;
    font-size: 16px;
    cursor: pointer;
    border-radius: 50%;
    transition: background 0.3s ease-in-out;
}

#close-button:hover {
    background: darkred;
}
`;

/**
     * Represents the world map page.
     */
export class WorldMapComponent extends HTMLElement {
    private _mapService = new MapService();
    /**
     * The "constructor" of a Web Component
     */
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
        this.closeMap();
        this.travelRoomByAlias();
    }

    /**
     * This function makes it possible to close the map and return to the game canvas page.
     */
    private closeMap(): void {
        const closeButton: Element | null | undefined = this.shadowRoot?.querySelector("#close-button");
        if (closeButton) {
            closeButton.addEventListener("click", () => {
                this.replaceWith(html`<game-canvas></game-canvas>`);
            });
        }
    }

    private travelRoomByAlias(): void {
        const rooms: NodeListOf<SVGRectElement> | undefined = this.shadowRoot?.querySelectorAll("rect");
        rooms?.forEach(room => {
            console.log(room);
            room.addEventListener("click", async () => {
                const roomAlias: string = room.id;
                console.log(roomAlias);
                await this._mapService.travelRoom(roomAlias);
                this.replaceWith(html`<game-canvas></game-canvas>`);
            });
        });
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        this.shadowRoot.innerHTML = `
            <style>
                ${styles}
            </style>

                    <svg width="100%" height="100%" viewBox="0 0 500 350" xmlns="http://www.w3.org/2000/svg">
                        <!-- Local Bar -->
                        <rect id="localBar" x="20" y="20" width="120" height="80" fill="lightgoldenrodyellow" stroke="black"/>
                        <text x="80" y="65" font-size="12" fill="white" text-anchor="middle">Local Bar</text>

                        <!-- Apartment Victim -->
                        <rect id="VictimAppartment" x="160" y="20" width="130" height="80" fill="lightgoldenrodyellow" stroke="black"/>
                        <text x="225" y="65" font-size="12" fill="white" text-anchor="middle">Apartment Victim</text>

                        <!-- Cafeteria -->
                        <rect id="BreakRoom" x="310" y="20" width="150" height="80" fill="lightgoldenrodyellow" stroke="black"/>
                        <text x="385" y="65" font-size="12" fill="white" text-anchor="middle">Cafeteria</text>

                        <!-- Office Detective -->
                        <rect id="DetectiveOffice" x="20" y="120" width="120" height="80" fill="lightgoldenrodyellow" stroke="black"/>
                        <text x="80" y="165" font-size="12" fill="white" text-anchor="middle">Office Detective</text>

                        <!-- Security Room -->
                        <rect id="securityRoom" x="160" y="120" width="130" height="80" fill="lightgoldenrodyellow" stroke="black"/>
                        <text x="225" y="165" font-size="12" fill="white" text-anchor="middle">Security Room</text>

                        <!-- Lab -->
                        <rect id="ForensicLab" x="310" y="120" width="150" height="80" fill="lightgoldenrodyellow" stroke="black"/>
                        <text x="385" y="165" font-size="12" fill="white" text-anchor="middle">Lab</text>

                        <!-- Crime Scene -->
                        <rect id="acidtankroom" x="20" y="220" width="120" height="60" fill="lightgoldenrodyellow" stroke="black"/>
                        <text x="80" y="250" font-size="12" fill="white" text-anchor="middle">Crime Scene</text>

                        <!-- Factory Office -->
                        <rect id="office-factory" x="160" y="220" width="300" height="60" fill="lightgoldenrodyellow" stroke="black"/>
                        <text x="310" y="250" font-size="12" fill="white" text-anchor="middle">Factory Office</text>
                    </svg>

            <div>
                <button id="close-button">X</button>
            </div>
        `;
    }
}
